import { DrEntity } from './dr-entity';
import { isNullOrUndefined } from './utils';


export class EmailServer extends DrEntity {
    attributes: Array<any>;
    mailSmtpAuth: boolean;
    mailUserId: string;
    mailUserPassword: string;
    smtpHostId: string;
    smtpHostPort: any;
    isUsingSsl: boolean;
    storeProtocol: string;

    constructor(value?: Partial<EmailServer>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
    }
}

export class EmailServerViewModel {
    static hostPortDefaultValue = '25';
    static hostPortSslDefaultValue = '587';

    model: Partial<EmailServer>;
    original: Partial<EmailServer>;

    constructor(value?: Partial<EmailServer>) {
        if (value) {
            this.model = value;

            if (isNullOrUndefined(this.model.smtpHostPort)) {
                this.model.smtpHostPort = EmailServerViewModel.hostPortDefaultValue;
            } else if (this.model.smtpHostPort === +EmailServerViewModel.hostPortSslDefaultValue) {
                this.model.isUsingSsl = true;
            }

            this.model.smtpHostPort = this.model.smtpHostPort === 0 ? '0' : this.model.smtpHostPort.toString();
        }

        if (this.model) {
            this.original = new EmailServer(this.model);
        }
    }

    isDirty(): boolean {
        const dirty = false;
        if (this.model.mailSmtpAuth !== this.original.mailSmtpAuth) {
            return true;
        }

        if (this.model.mailUserId !== this.original.mailUserId) {
            return true;
        }

        if (this.model.mailUserPassword !== this.original.mailUserPassword) {
            return true;
        }

        if (this.model.smtpHostId !== this.original.smtpHostId) {
            return true;
        }

        if (this.model.smtpHostPort !== this.original.smtpHostPort) {
            return true;
        }

        if (this.model.storeProtocol !== this.original.storeProtocol) {
            return true;
        }

        return dirty;
    }
}
